import {XauditModel} from '../xaudit.model';
import {DataARClaimItemModel} from './data-ar-claim-item.model';
import {PatientInsuranceDataModel} from '../patient/patient-insurance-data.model';
import {PatientDataModel} from '../patient/patient-data.model';
import { ReportADAExtraParams } from 'src/app/modules/reports/models/ReportADAExtraParamsModel.model';

export class DataARClaimModel extends XauditModel {
  ARClaimID: string;
  ClaimDate: Date;
  PatientInsuranceID: string;
  enumClaimStatusID: string;
  LOCID: number;
  enumClaimTypeID: string;
  TDOClaimNumber: number;
  DoctorARLocId: string;
  enumClaimCheckStatusID: string;
  enumClaimMethodID: string;
  ClosedDate: Date;
  ProviderDoctorId: string;
  APIID: string;
  EncodedClaim: string;
  SentDate: Date;
  AdditionalInfoJSON: string;

  dataARClaimItems: DataARClaimItemModel[];
  dataPatientInsurance4AR: PatientInsuranceDataModel;

  DATA_PATIENT: PatientDataModel;
}


export class AdditionalInfo {
  dxcClaimId: string;
  dxcAttachmentId: string;
  ADAParameters : ReportADAExtraParams;
}